<template>
  <BootstrapDialog
    title="添加跟踪进度"
    ref="dialog"
    size="lg"
    @afterClose="afterClose()"
  >
    <template v-slot:body>
      <div class="row" style="padding-top:10px">
        <div class="col-sm-8 col-sm-offset-2">
          <form role="form" class="form-horizontal">
            <div class="form-group">
              <label class="col-sm-2 control-label"
                ><span class="required">*</span>联系方式</label
              >
              <div class="col-sm-10">
                <select
                  name="lxfs"
                  v-model="model.lxfs"
                  id="lxfs"
                  class="form-control"
                  v-validate="{ required: true, max: 50 }"
                  data-vv-as="联系方式"
                >
                  <option value="">-请选择-</option>
                  <option
                    :value="lxfs.value"
                    :key="lxfs.value"
                    v-for="lxfs in lxfsArr"
                    >{{ lxfs.text }}</option
                  >
                </select>
                <span class="error_validate_msg"
                  ><em>{{ errors.first("lxfs") }}</em></span
                >
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label"
                ><span class="required">*</span>联系时间</label
              >
              <div class="col-sm-10">
                <DateTimePicker
                  v-model="model.cjsj"
                  name="cjsj"
                  v-validate="{ required: true }"
                  data-vv-as="联系时间"
                  format="YYYY-MM-DD HH:mm:ss"
                  input-class="form-control"
                  style="width:300px"
                  :show-buttons="true"
                  clearable
                ></DateTimePicker>
                <span class="error_validate_msg"
                  ><em>{{ errors.first("cjsj") }}</em></span
                >
              </div>
            </div>

            <div class="form-group">
              <label class="col-sm-2 control-label"
                ><span class="required">*</span>联系内容</label
              >
              <div class="col-sm-10">
                <div>
                  <button
                    class="btn btn-primary"
                    type="button"
                    @click="addImageUpload"
                  >
                    上传跟踪记录截图 
                  </button>
                </div>
                <div
                  v-for="(item, index) in imgArr"
                  :key="index"
                  class="imgBox"
                >
                  <image-upload
                    class="image-upload"
                    v-model="item.url"
                  ></image-upload>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="row">
        <button class="btn btn-primary" type="button" @click="save()">
          保存
        </button>
        <button
          style="margin-left:10px"
          class="btn btn-default"
          type="button"
          @click="close()"
        >
          关闭
        </button>
      </div>
    </template>
  </BootstrapDialog>
</template>
<script>
import { LXFS } from "@/plugins/enums.js";
export default {
  name: "OrgUserAdd",
  components: {},
  data: function() {
    return {
      lxfsArr: [], // 联系方式
      imgArr: [
        {
          url: null,
        },
      ],
      jsList: [],
      model: {
        zcId: "", //注册id
        lxfs: "", // 联系方式枚举
        lxnr: "", // 联系内容（图片逗号拼接）
        cjsj: "", // 联系时间
      },
    };
  },
  created() {
    this.lxfsArr = LXFS;
  },
  methods: {
    addImageUpload() {
      this.imgArr.push({
        url: null,
      });
    },
    //点击上传图片
    uploadHeadImg: function() {
      this.$el.querySelector(".image-upload").click();
    },
    reset: function() {
      this.model = {
        zcId: "", //注册id
        lxfs: "", // 联系方式枚举
        lxnr: "", // 联系内容（图片逗号拼接）
        cjsj: "", // 联系时间
      };
    },
    open(row) {
      this.model.zcId = row.zcid;
      this.imgArr = [];
      (this.model.cjsj = ""), (this.model.lxfs = ""), this.$refs.dialog.open();
    },
    close: function() {
      this.$refs.dialog.close();
    },
    afterClose: function() {
      this.$validator.reset();
      this.reset();
    },
    showOption: function(item) {
      return item.code + "-" + item.text;
    },
    save() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          //如果表单校验通过才可以保存
          let resArr = [];
          this.imgArr.forEach((item) => {
            resArr.push(item.url);
          });
          resArr = resArr.filter((item) => item);
          this.model.lxnr = resArr.join(",");
          let poUrl = "/htgl/biz/trackRecord/create";
          this.$http.post(poUrl, this.model).then((res) => {
            if (res.data == true) {
              this.$success("操作成功", () => {
                this.close();
                this.$parent.search(); //刷新列表
              });
            }
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.imgBox {
  display: inline-block;
}
.image-upload {
  padding: 20px;
  margin: 10px;
}

.image-upload {
  height: auto;
  overflow: hidden;
}
.image-upload img {
  height: 200px !important;
}
.col-sm-10 .image-upload span {
  position: relative !important;

  /* display: inline-block; */
}
</style>
